export default "__VITE_ASSET__b98eeba8__"